import './styles/inforeg.css'
import { useLocation, useNavigate } from "react-router-dom"
import { useEffect, useState } from 'react'

//Components
import Loader from '../components/loader'
import Snack from '../components/snack'
import Menu from '../components/menu'

//Extras
import { fontType, main } from '../assets/extras'
import { arrayUnion, collection, doc, getDoc, getDocs, increment, query, updateDoc, where } from 'firebase/firestore'
import { db } from '../assets/connections'
import { MdDeleteOutline } from "react-icons/md"
import { CiCircleCheck } from "react-icons/ci"

const InfoReg = () => {

    const navigate = useNavigate()
    
    const location = useLocation()
    const regId = location.state ? location.state.regId : null
    const ref = location.state ? location.state.ref : null
    const id = location.state ? location.state.id : null
    const regRef = location.state ? location.state.regRef : null
    const academia = location.state ? location.state.academia : null

    const [variables, setVariables] = useState({
        loading: true,
        students: [],
        data: null
    })

    //Control del mensaje snack
    const showMessage = (message, status) => {
        let contSnack = document.getElementById("contSnack")

        let snack = document.createElement("div")
        snack.classList.add("snack")

        snack.innerHTML = status == "success" ?
            "<i class='fa-regular fa-circle-check fa-beat' style='color: #56d600;'></i>" +
            "<p style='font-family:" + fontType.text + ";'>" + message + "</p>" +
            "<div className='snackBar' style='background-color: #56d600;'></div>"
            : status == "warning" ?
                "<i class='fa-solid fa-triangle-exclamation fa-beat' style='color: #f9b92f;'></i>" +
                "<p style='font-family:" + fontType.text + ";'>" + message + "</p>" +
                "<div className='snackBar' style='background-color: #f9b92f;'></div>"
                : status == "error" ?
                    "<i class='fa-solid fa-circle-xmark fa-beat' style='color: #c20000;'></i>" +
                    "<p style='font-family:" + fontType.text + ";'>" + message + "</p>" +
                    "<div className='snackBar' style='background-color: #c20000;'></div>"
                    : ""

        contSnack.appendChild(snack)
        setTimeout(() => {
            snack.remove()
        }, 5000)
    }

    //Formatea los dias de las clases
    const formatDays = (dias_clase) => {
        if(id.split("-").length === 1 || id.split("-")[2] === "TEMP"){
            var dias = ""
            var hora = ""
            dias_clase.map(v => {
                var dia = ""
                for(let i = 0; i < 3; i++){
                    dia += v.dia[i]
                }
                if(dias){
                    dias += " / " + dia
                } else {
                    dias = dia
                    hora = v.de + " a " + v.a
                }
            })
            return dias + " de " + hora
        }
        return "Hora asignada por el profesor"
    }

    //Funcion que actualiza la informacion del registro
    const updateReg = async () => {

        //Ahora vamos a agregar las asistencias en caso de que haya jugadores nuevos en las asistencias
        variables.data.alumnos_clase.map(async (v, i) => {
            if(v.asist == true){
                await updateDoc(doc(doc(db, ref), "Jugador", v.id), {
                    asistencias: arrayUnion({
                        fecha_clase: variables.data.fecha_clase,
                        nombre_clase: variables.data.nombre_clase,
                        profesor_clase: variables.data.nombre_profesor,
                        hora_clase: formatDays(variables.data.dias_clase),
                        id: regId
                    })
                })
            }
        })

        //Actualizamos nuestras clases muestra
        variables.data.clasesMuestra.map(async (v, i) => {
            if(v.asisted != undefined){
                if(v.asisted === false){
                    await updateDoc(doc(db, "ClaseMuestra", v.id), {
                        asistio: false
                    })
                } else if(v.asisted === true){
                    await updateDoc(doc(db, "ClaseMuestra", v.id), {
                        asistio: true
                    })
                }
            }
        })

        //Formateamos los datos de los jugadores que van a ser almacenados
        for (let i = 0; i < variables.data.alumnos_clase.length; i++) {
            variables.data.alumnos_clase[i] = {
                id: variables.data.alumnos_clase[i].id,
                nombre: variables.data.alumnos_clase[i].nombre
            }
        }

        await updateDoc(doc(doc(db, regRef), "Historial", regId), { ...variables.data }).then(r => {

            //Primero vamos a quitar las asistencias en caso de que haya jugadores a los que quitamos asistencia
            variables.students.map(async v => {
                if (v.asist === false) {
                    await getDoc(doc(doc(db, ref), "Jugador", v.id)).then(async r => {
                        if(r.exists()){
                            console.log("SI")
                            var new_asistencias = r.data().asistencias
                            new_asistencias = new_asistencias.filter(v2 => v2.id != regId)
        
                            await updateDoc(doc(doc(db, ref), "Jugador", v.id), {
                                asistencias: new_asistencias
                            })
                        }
                    })
                }
            })

            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            setTimeout(() => {
                showMessage("Registro modificado", "success")
                setTimeout(() => {
                    window.history.back()
                }, 2000)
            }, 100)

        }).catch(e => {
            console.log(e.code + " " + e.message)
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            setTimeout(() => {
                showMessage("Error al actualizar el registro", "error")
            }, 100)
        })
    }

    //Funcion que quita las asistencias de un jugador
    const takeOutPlayer = (d, index) => {
        if (d.asist == undefined) {
            d = { ...d, asist: false }
        } else if (d.asist === true) {
            d = { ...d, asist: null }
        }
        variables.students.push(d)
        variables.data.alumnos_clase.splice(index, 1)

        setVariables(prev => ({
            ...prev
        }))
    }

    //Funcion para agregar jugador a las asistencias
    const insertPlayer = (d, index) => {
        if (d.asist === null) {
            d = { ...d, asist: true }
        } else if (d.asist === false) {
            d = { ...d, asist: null }
        }

        variables.data.alumnos_clase.push(d)
        variables.students.splice(index, 1)

        setVariables(prev => ({
            ...prev
        }))

    }

    /**
     * FUNCIONES PARA LAS CLASES MUESTRA, TANTO AGREGAR COMO QUITAR ASISTENCIA
     */
    const asisted = (index) => {
        variables.data.clasesMuestra[index].asisted = true
        setVariables(prev => ({
            ...prev
        }))
    }
    const notAsisted = (index) => {
        variables.data.clasesMuestra[index].asisted = false
        setVariables(prev => ({
            ...prev
        }))
    }

    //Funcion que filtra a los jugadores de los que asistieron y de los que no
    const filterPlayers = (data, players) => {
        for (let i = 0; i < data.alumnos_clase.length; i++) {
            var currPlayer = data.alumnos_clase[i].id
            for (let j = 0; j < players.length; j++) {
                if (currPlayer == players[j].id) {
                    players.splice(j, 1)
                }
            }
        }

        setVariables(prev => ({
            ...prev,
            data: data,
            students: players,
            loading: false
        }))
    }

    //Funcion que formatea el nombre de los jugadores para que quepan en el recuadro
    const formatName = (nombre) => {
        var name = ""
        var cont = 0
        for (let i = 0; i < nombre.length; i++) {
            name += nombre[i]
            cont++

            if (cont == 15) {
                break
            }
        }

        if (cont == 15) {
            return name + "..."
        } else {
            return name
        }
    }

    //Funcion que busca todos los alumnos que esten dentro de la clinica
    const getStudents = async (data) => {
        await getDocs(query(collection(doc(db, ref), "Jugador"), where("clases_jugador", "array-contains", id))).then(r => {
            var aux = []
            r.docs.map(v => {
                aux.push({
                    id: v.id,
                    nombre: v.data().nombre_jugador,
                    asist: null
                })
            })

            filterPlayers(data, aux)
        }).catch(e => {
            console.log(e.code + " " + e.message)
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            setTimeout(() => {
                showMessage("Error de conexion", "error")
            }, 100)
        })
    }

    //Funcion que obtiene los datos del registro
    const getData = async () => {
        await getDoc(doc(doc(db, regRef), "Historial", regId)).then(r => {
            getStudents(r.data())
        }).catch(e => {
            console.log(e.code + " " + e.message)
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            setTimeout(() => {
                showMessage("Error de conexion", "error")
            }, 100)
        })
    }

    /**
     * FUNCIONES DE LAS CLASES EXTRA
     */
    //Funcion que obtiene los datos del registro
    const getDataExt = async () => {
        await getDoc(doc(doc(db, regRef), "Historial", regId)).then(r => {
            setVariables(prev => ({
                ...prev,
                loading: false,
                data: r.data()
            }))
        }).catch(e => {
            console.log(e.code + " " + e.message)
            setVariables(prev => ({
                ...prev,
                loading: false
            }))
            setTimeout(() => {
                showMessage("Error de conexion", "error")
            }, 100)
        })
    }

    useEffect(() => {
        if(!sessionStorage.getItem("homeFlag") || !ref){
            navigate("/home", { replace: true })
        } else {
            if(id.split("-").length === 1 || id.split("-")[2] === "TEMP"){
                getData()
            } else {
                getDataExt()
            }
        }
    }, [])

    if (variables.loading)
        return (
            <Loader loading={variables.loading} />
        )

    if (!variables.loading)
        return (
            <div className='mainInfoRegNormal'>

                <Snack />

                {
                    id.split("-").length === 1 || id.split("-")[2] === "TEMP" ?
                        <div style={{
                            width: "100%"
                        }}>
                            <h2 style={{
                                backgroundColor: main,
                                fontFamily: fontType.title,
                                paddingBottom: 0
                            }}>{variables.data.nombre_clase}</h2>
                            <h2 style={{
                                backgroundColor: main,
                                fontFamily: fontType.text,
                                marginTop: -40,
                                marginBottom: 40,
                                fontSize: 18,
                                padding: 10,
                                paddingBottom: 20,
                                paddingTop: 0
                            }}>{
                                localStorage.getItem("authToken") ? 
                                    JSON.parse(localStorage.getItem("authToken")).nombre_academia
                                : ""
                            }</h2>
                        </div>
                    : 
                        <div style={{
                            width: "100%"
                        }}>
                            <h2 style={{
                                backgroundColor: main,
                                fontFamily: fontType.title,
                                paddingBottom: 0
                            }}>CLASES EXTRAS</h2>
                            <h2 style={{
                                backgroundColor: main,
                                fontFamily: fontType.text,
                                marginTop: -40,
                                marginBottom: 40,
                                fontSize: 18,
                                padding: 10,
                                paddingBottom: 20,
                                paddingTop: 0
                            }}>{
                                localStorage.getItem("authToken") ? 
                                    JSON.parse(localStorage.getItem("authToken")).nombre_academia
                                : ""
                            }</h2>
                        </div>
                }

                <Menu
                    academia={academia}
                    reference={ref}
                />

                {
                    id.split("-").length === 1 || id.split("-")[2] === "TEMP" ?
                        variables.data.wasGiven === true ?

                            <div className='contContainers'>

                                <div className='cont-one' style={{
                                    fontFamily: fontType.text
                                }}>

                                    <p style={{
                                        fontSize: 16
                                    }}>La clase fue impartida</p>
                                    <div className='contInfo'>
                                        <p>{variables.data.fecha_clase}</p>
                                        <p>{variables.data.hora_clase}</p>

                                        {
                                            variables.data.duracion_clase ?
                                                <div className='contDuracion'>
                                                    <p>Duracion de clase(hrs):</p>
                                                    <div className='custom-select'>
                                                        <select value={variables.data.duracion_clase} onChange={e => {
                                                            setVariables(prev => ({
                                                                ...prev,
                                                                data: {
                                                                    ...prev.data,
                                                                    duracion_clase: e.target.value
                                                                }
                                                            }))
                                                        }}>
                                                            <option value={1}>1 Hora </option>
                                                            <option value={2}>2 Horas</option>
                                                            <option value={3}>3 Horas</option>
                                                            <option value={4}>4 Horas</option>
                                                            <option value={5}>5 Horas</option>
                                                            <option value={6}>6 Horas</option>
                                                            <option value={7}>7 Horas</option>
                                                            <option value={8}>8 Horas</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                : null
                                        }
                                    </div>

                                    <p style={{
                                        marginTop: 10,
                                        fontStyle: "italic"
                                    }}>{variables.data.comentarios_clase ? variables.data.comentarios_clase : '"Sin comentarios"'}</p>
                                </div>
                                <div className='cont-two'>
                                    <p style={{
                                        fontFamily: fontType.title,
                                        fontSize: 18,
                                        marginBottom: 10
                                    }}>ASISTENCIAS</p>

                                    {
                                        variables.data.alumnos_clase.length > 0 ?
                                            variables.data.alumnos_clase.map((v, index) => {
                                                return (
                                                    <div className='alumn'>
                                                        <p className='name' style={{
                                                            fontFamily: fontType.text
                                                        }}>
                                                            {
                                                                formatName(v.nombre)
                                                            }
                                                        </p>
                                                        <div className='delbutton' onClick={() => takeOutPlayer(v, index)}>
                                                            <MdDeleteOutline size={25} color='red' />
                                                        </div>
                                                    </div>
                                                )
                                            })
                                        :
                                            <div>
                                                <p style={{
                                                    fontFamily: fontType.text,
                                                    marginBottom: 80,
                                                    marginTop: 50
                                                }}>No hay asistencias de jugadores</p>
                                            </div>
                                    }

                                    {
                                        variables.data.jugadores_reposicion != undefined ?
                                            variables.data.jugadores_reposicion.length > 0 ?
                                                <p style={{
                                                    fontFamily: fontType.title,
                                                    marginTop: 20,
                                                    marginBottom: 10
                                                }}>REPOSICIONES</p>
                                            : null
                                        : null
                                    }

                                    {
                                        variables.data.jugadores_reposicion != undefined ?
                                            variables.data.jugadores_reposicion.length > 0 ?
                                                variables.data.jugadores_reposicion.map((v, index) => {
                                                    return (
                                                        <div className='alumn'>
                                                            <p className='name' style={{
                                                                fontFamily: fontType.text
                                                            }}>
                                                                {
                                                                    formatName(v.nombre_jugador)
                                                                }
                                                            </p>
                                                        </div>
                                                    )
                                                })
                                                : null
                                            : null
                                    }

                                    {
                                        variables.students.length > 0 ?
                                            <p style={{
                                                fontFamily: fontType.title,
                                                marginTop: 20,
                                                marginBottom: 10
                                            }}>JUGADORES NO ASISTIDOS</p>
                                            : null
                                    }

                                    {
                                        variables.students.length > 0 ?
                                            variables.students.map((v, index) => {
                                                return (
                                                    <div className='alumn'>
                                                        <p className='name' style={{
                                                                fontFamily: fontType.text
                                                            }}>
                                                            {
                                                                formatName(v.nombre)
                                                            }
                                                        </p>
                                                        <div onClick={() =>  insertPlayer(v, index)}>
                                                            <CiCircleCheck size={28} color='green' strokeWidth={1} />
                                                        </div>
                                                    </div>
                                                )
                                            })

                                            : null
                                    }

                                    {
                                        variables.data.clasesMuestra.length > 0 ?
                                            <p style={{
                                                fontFamily: fontType.title,
                                                marginTop: 20,
                                                marginBottom: 10
                                            }}>CLASES MUESTRA</p>
                                            : null
                                    }

                                    {
                                        variables.data.clasesMuestra.length > 0 ?
                                            variables.data.clasesMuestra.map((v, index) => {
                                                return (
                                                    <div className='alumn'>
                                                        <p className='name' style={{
                                                                fontFamily: fontType.text
                                                            }}>
                                                            {
                                                                v.nombre
                                                            }
                                                        </p>
                                                    </div>
                                                )
                                            })

                                            : null
                                    }

                                    <p style={{
                                        fontFamily: fontType.title,
                                        fontSize: 18,
                                        marginTop: 20
                                    }}>LECCION</p>
                                    <button style={{
                                        backgroundColor: "black",
                                        width: 200,
                                        padding: 10,
                                        color: "white",
                                        border: "none",
                                        borderRadius: 5,
                                        fontFamily: fontType.subTitle,
                                        marginBottom: 50
                                    }}>
                                        {variables.data.leccion_clase}
                                    </button>

                                    <button className='saveButton' onClick={() => {
                                        setVariables(prev => ({
                                            ...prev,
                                            loading: true
                                        }))
                                        updateReg()
                                    }} style={{
                                        backgroundColor: main,
                                        fontFamily: fontType.title
                                    }}>
                                        ACTUALIZAR
                                    </button>

                                </div>
                            </div>
                        :
                            
                            <div style={{
                                width: "95%",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                flexDirection: "column",
                                fontFamily: fontType.text,
                                padding: 30,
                                border: "2px solid black",
                                borderRadius: 10
                            }}>
                                <p>{variables.data.fecha_clase} | {variables.data.hora_clase}</p>

                                <div style={{
                                    width: "100%",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    flexDirection: "column",
                                    padding: 20
                                }}>
                                    <div style={{
                                        display: "flex",
                                        alignItems: "center",
                                        marginBottom: 40
                                    }}>
                                        <p>La clase no fue impartida: </p>
                                        <p style={{
                                            fontWeight: "bold",
                                            marginLeft: 5,
                                            textDecoration: "underline"
                                        }}>{variables.data.reasons}</p>
                                    </div>
                                    <textarea 
                                        className='inputNo' 
                                        cols="40" 
                                        rows="5"
                                        disabled={true}
                                        value={variables.data.details === "" ?
                                        "No hay mas razones..." : variables.data.details} 
                                    ></textarea>
                                </div>
                            </div>
                    :
                    <div className='contExtra' style={{
                        width: "95%",
                        border: "2px solid black",
                        padding: 30,
                        borderRadius: 10,
                        boxShadow: "1px 1px 2px black",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexDirection: "column",
                        fontFamily: fontType.text,
                        maxWidth: "1000px"
                    }}>
                        <div>
                            <p>{variables.data.fecha_clase} | {variables.data.hora_clase}</p>
                        </div>

                        <p style={{
                            width: "100%",
                            marginTop: 30,
                            marginBottom: 10,
                            fontFamily: fontType.title
                        }}>Asistencias</p>

                        <div style={{
                            borderWidth: 1,
                            width: "90%",
                            marginTop: 3,
                            borderRadius: 5,
                            padding: 10,
                            color: "black",
                            borderStyle: "solid"
                        }}>
                            {
                                variables.data.jugadores_registrados.map(v => {
                                    return (
                                        <div style={{
                                            borderBottomWidth: 1,
                                            borderColor: main,
                                            padding: 3,
                                            marginTop: 5,
                                            marginBottom: 10,
                                            borderBottomStyle: "solid"
                                        }}>
                                            <p>{v.nombre}</p>
                                        </div>
                                    )
                                })
                            }
                            {
                                variables.data.jugadores_noRegistrados.map(v => {
                                    return (
                                        <div style={{
                                            borderBottomWidth: 1,
                                            borderColor: main,
                                            padding: 3,
                                            marginTop: 5,
                                            marginBottom: 10,
                                            borderBottomStyle: "solid"
                                        }}>
                                            <p>{v.nombre}</p>
                                        </div>
                                    )
                                })
                            }
                        </div>

                        <p style={{
                            width: "100%",
                            marginTop: 20,
                            fontFamily: fontType.title
                        }}>Comentarios</p>
                        <div style={{
                            borderWidth: 1,
                            width: "90%",
                            marginTop: 3,
                            borderRadius: 5,
                            padding: 10,
                            alignItems: "center",
                            borderStyle: "solid"
                        }}>
                            <p style={{
                                textAlign: "center"
                            }}>{variables.data.comentarios_clase === "" ? "Sin comentarios" : variables.data.comentarios_clase}</p>
                        </div>

                        <div style={{
                            width: "100%",
                            display: "flex",
                            flexDirection: "row",
                            marginTop: 20
                        }}>
                            <p style={{
                                fontFamily: fontType.title
                            }}>Leccion:   </p>
                            <p style={{
                                marginLeft: 5
                            }}>{variables.data.leccion_clase === "" ? "No especificada" : variables.data.leccion_clase}</p>
                        </div>
                        <div style={{
                            width: "100%",
                            display: "flex",
                            flexDirection: "row",
                            marginTop: 10
                        }}>
                            <p style={{
                                fontFamily: fontType.title
                            }}>Duracion de clase:   </p>
                            <p style={{
                                marginLeft: 5
                            }}>{variables.data.duracion_clase}hrs.</p>
                        </div>
                    </div>
                }

            </div>
        )
}

export default InfoReg